import { AnyAction } from 'redux';
import { ClientType } from 'domain/types/client.type';
import { ClientReducerType } from 'model/reducers/ClientReducerType';

const initialState: ClientReducerType = {
  selectedClient: null,
  clients: [],
  error: null
};

/**
 * Client reducer for managing client-related state
 */
const clientReducer = (state = initialState, action: AnyAction): ClientReducerType => {
  const { type, payload } = action;
  
  switch (type) {
    case ClientType.SELECT_CLIENT:
      return {
        ...state,
        selectedClient: payload.selectedClient
      };
      
    case ClientType.FETCH_CLIENTS_REQUEST:
      return {
        ...state,
        error: null
      };
      
    case ClientType.FETCH_CLIENTS_SUCCESS:
      return {
        ...state,
        clients: payload.clients,
        error: null
      };
      
    case ClientType.FETCH_CLIENTS_FAILURE:
      return {
        ...state,
        error: payload.error
      };
      
    default:
      return state;
  }
};

export default clientReducer;